export default __webpack_public_path__ + "static/media/5l-inact.597715ee.svg";